// extracted by mini-css-extract-plugin
export default {"background":"Loader_background__vvPB4","loader":"Loader_loader__lUf7j","fullHeight":"Loader_fullHeight__ws8AY"};